v-autocomplete
<template>
  <div>
    <div class="px-md-12 px-lg-12 pr-4 pt-12">
      <div class="mb-4">
        <span class="main-title">
          Nos fale um pouco <br />
          mais sobre você...
        </span>
      </div>

      <v-form ref="form">
        <v-row dense class="ma-0 pa-0">
          <v-col cols="12" sm="12" md="8" lg="8">
            <strong>E-mail</strong>
            <v-text-field
              v-model="proponente.email"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[
                (v) => !!v || 'E-mail obrigatório',
                (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
              ]"
              outlined
              placeholder="example@mail.com"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Celular</strong>
            <v-text-field
              v-model="proponente.phone"
              class="input-field"
              v-mask="['(##)####-####', '(##)#####-####']"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Celular obrigatório']"
              outlined
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="5" lg="5">
            <strong>Profissão</strong>
            <v-text-field
              v-model="proponente.job"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Profissão obrigatória']"
              outlined
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="3" lg="3">
            <strong>Residente no Brasil?</strong>
            <v-autocomplete
              v-model="proponente.residentInBrasil"
              :items="generalOptions"
              :rules="[(v) => v != null || 'Campo obrigatório']"
              item-text="text"
              item-value="value"
              append-icon="mdi-chevron-down"
              no-data-text="Nenhum dado disponivel"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>País de nascimento</strong>
            <v-text-field
              v-model="proponente.country"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'País obrigatório']"
              outlined
              placeholder="Ex: Brasil"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Nacionalidade</strong>
            <v-text-field
              v-model="proponente.nationality"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Nacionalidade obrigatória']"
              outlined
              placeholder="Ex: Brasileiro"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Sexo</strong>
            <v-autocomplete
              v-model="proponente.sexo"
              :items="genders"
              append-icon="mdi-chevron-down"
              no-data-text="Nenhum dado disponivel"
              :rules="[(v) => v != null || 'Sexo obrigatório']"
              class="input-field"
              background-color="#f5f5f5"
              item-text="text"
              item-value="value"
              outlined
              placeholder="Preenchido"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Fumante?</strong>
            <v-autocomplete
              v-model="proponente.smoker"
              :items="generalOptions"
              :rules="[(v) => v != null || 'Campo obrigatório']"
              item-text="text"
              item-value="value"
              append-icon="mdi-chevron-down"
              no-data-text="Nenhum dado disponivel"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>É aponsetado?</strong>
            <v-autocomplete
              :items="retireeOptions"
              v-model="proponente.aposentado"
              append-icon="mdi-chevron-down"
              no-data-text="Nenhum dado disponivel"
              :rules="rules"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Profissional liberal?</strong>
            <v-autocomplete
              :items="generalOptions"
              :rules="[(v) => v != null || 'Campo obrigatório']"
              item-text="text"
              item-value="value"
              v-model="proponente.liberal"
              append-icon="mdi-chevron-down"
              no-data-text="Nenhum dado disponivel"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Origem do recurso</strong>
            <v-autocomplete
              v-model="proponente.resourceOrigin"
              class="input-field"
              :items="[
                'Desejo não fornecer',
                'Aplicações financeiras',
                'Aposentadoria',
                'Bens imóveis',
                'Comissões',
                'Doações',
                'Herança',
                'Salário / Pro Labore',
                'Outros',
              ]"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Origem obrigatória']"
              outlined
              placeholder="Selecione"
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense class="ma-0 pa-0" :key="key">
          <v-col cols="12" sm="12" md="9" lg="9">
            <strong>CEP</strong>
            <v-text-field
              @keyup="getCep"
              :rules="rules"
              v-model="proponente.cep"
              class="input-field"
              v-mask="['#####-###']"
              background-color="#f5f5f5"
              outlined
              placeholder="00000-000"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="3" class="d-flex align-center">
            <a
              target="_blank"
              href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
            >
              Não sei meu CEP
            </a>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Endereço</strong>
            <v-text-field
              v-model="proponente.address"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Endereço obrigatório']"
              outlined
              placeholder="Rua"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Número</strong>
            <v-text-field
              v-model="proponente.number"
              class="input-field"
              type="number"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Número obrigatório']"
              outlined
              placeholder="000"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Bairro</strong>
            <v-text-field
              v-model="proponente.neighbourhood"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Bairro obrigatório']"
              outlined
              placeholder="Bairro"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Cidade</strong>
            <v-text-field
              v-model="proponente.city"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Cidade obrigatório']"
              outlined
              placeholder="Cidade"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Estado</strong>
            <v-text-field
              v-model="proponente.state"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Estado obrigatório']"
              outlined
              placeholder="UF"
              d
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Complemento</strong>
            <v-text-field
              v-model="proponente.complement"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Complemento"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <v-col cols="12">
            <v-card elevation="0" class="primary-card pa-4" color="#f5f5f5">
              <v-row class="ma-0" justify="space-between" align="center">
                <v-col>
                  <span class="ml-1 label-bold">Beneficiários</span>
                </v-col>
                <v-col lg="3">
                  <v-btn
                    elevation="0"
                    class="next-button"
                    @click="addRecipient"
                  >
                    Adicionar
                  </v-btn>
                </v-col>
              </v-row>

              <v-card
                style="border-radius: 10px"
                v-if="beneficiarios.length > 0"
                elevation="0"
                color="#fff"
              >
                <v-form ref="formBeneficiarios">
                  <v-row
                    v-for="(element, i) in beneficiarios"
                    :key="i"
                    class="ma-0"
                    justify="space-around"
                    align="center"
                  >
                    <v-col cols="12">
                      <span class="ml-1 input-label">Grau de afinidade</span>
                      <v-select
                        v-model="element.afinidade"
                        hide-details
                        :items="['Cônjuge', 'Pai', 'Mãe', 'Filho(a)', 'Outros']"
                        class="input-field"
                        background-color="#f5f5f5"
                        placeholder="Grau de afinidade"
                        :rules="[(v) => !!v || 'Afinidade obrigatório']"
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="element.afinidade == 'Outros'">
                      <v-text-field
                        v-model="element.othersDegrees"
                        hide-details
                        class="input-field"
                        background-color="#f5f5f5"
                        placeholder="Digite o outro tipo de afinidade"
                        :rules="[(v) => !!v || 'Afinidade obrigatório']"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <span class="ml-1 input-label">Nome completo</span>

                      <v-text-field
                        v-model="element.name"
                        hide-details
                        class="input-field"
                        background-color="#f5f5f5"
                        placeholder="Nome completo"
                        :rules="[(v) => !!v || 'Nome obrigatório']"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <span class="ml-1 input-label">Data de nascimento</span>
                      <v-text-field
                        v-model="element.birth"
                        prepend-inner-icon="mdi-calendar-today"
                        :rules="[(v) => !v || TestDate(v) || 'Data Inválida']"
                        class="input-field"
                        background-color="#f5f5f5"
                        outlined
                        v-mask="['##/##/####']"
                        placeholder="Preenchido"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <span class="ml-1 input-label">Participação</span>

                      <v-text-field
                        v-model="element.participation"
                        class="input-field"
                        background-color="#f5f5f5"
                        placeholder="Participação"
                        v-mask="['#', '##', '###']"
                        suffix="%"
                        max="100"
                        min="0"
                        :rules="[
                          (v) => !!v || 'Participação obrigatória',
                          (v) =>
                            !v || calcPercentage() || 'Percentual Inválido',
                        ]"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        block
                        class="delete-button"
                        color="error"
                        elevation="0"
                        @click="removeRecipient(i)"
                      >
                        Remover
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <div class="px-10">
      <div
        class="my-6 mr-2 d-flex justify-space-between align-center flex-wrap"
      >
        <v-form ref="form" class="container-center">
          <v-row class="ma-0" align="center">
            <v-col>
              <v-autocomplete
                :items="['Boleto', 'Débito em conta']"
                v-model="proponente.payment"
                append-icon="mdi-chevron-down"
                no-data-text="Nenhum dado disponivel"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                class="input-field"
                background-color="#f5f5f5"
                outlined
                hide-details="auto"
                placeholder="Forma de pagamento"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>

        <div></div>
      </div>

      <div v-if="proponente.payment == 'Boleto'" class="px-10">
        <h4>Dia de vencimento</h4>
        <p>
          O dia de vencimento selecionado será utilizado da segunda parcela em
          diante.
        </p>
        <v-btn-toggle
          v-model="proponente.vencimento"
          background-color="secondary"
          class="fatherOfBtnExpirationDay"
        >
          <v-btn value="1" class="btnsExpirationDay">
            <span>1</span>
          </v-btn>
          <v-btn value="5" class="btnsExpirationDay">
            <span>5</span>
          </v-btn>
          <v-btn value="10" class="btnsExpirationDay">
            <span>10</span>
          </v-btn>
          <v-btn value="15" class="btnsExpirationDay">
            <span>15</span>
          </v-btn>
          <v-btn value="20" class="btnsExpirationDay">
            <span>20</span>
          </v-btn>
          <v-btn value="25" class="btnsExpirationDay">
            <span>25</span>
          </v-btn>
          <v-btn value="30" class="btnsExpirationDay">
            <span>30</span>
          </v-btn>
        </v-btn-toggle>
      </div>

      <v-row class="ma-0" v-if="proponente.payment == 'Débito em conta'">
        <v-col cols="12" sm="4">
          <v-autocomplete
            :items="banks"
            item-text="label"
            item-value="label"
            v-model="proponente.banco"
            append-icon="mdi-chevron-down"
            no-data-text="Nenhum dado disponivel"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            class="input-field"
            background-color="#f5f5f5"
            outlined
            hide-details="auto"
            placeholder="Selecione seu banco"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="4">
          <v-text-field
            v-model="proponente.agencia"
            no-data-text="Nenhum dado disponivel"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            class="input-field"
            background-color="#f5f5f5"
            outlined
            v-mask="['###', '###-#', '###-##']"
            hide-details="auto"
            placeholder="Digite a agência"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="4">
          <v-text-field
            v-model="proponente.conta"
            no-data-text="Nenhum dado disponivel"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            class="input-field"
            background-color="#f5f5f5"
            outlined
            v-mask="['###-#', '####-#', '#####-#', '######-#']"
            hide-details="auto"
            placeholder="Digite a conta"
          >
          </v-text-field>
        </v-col>
        <v-col>
          <div class="px-10">
            <h4>Dia de vencimento</h4>
            <p>
              O dia de vencimento selecionado será utilizado da segunda parcela
              em diante.
            </p>
            <v-btn-toggle
              v-model="proponente.vencimento"
              background-color="secondary"
              class="fatherOfBtnExpirationDay"
            >
              <v-btn value="1" class="btnsExpirationDay">
                <span>1</span>
              </v-btn>
              <v-btn value="5" class="btnsExpirationDay">
                <span>5</span>
              </v-btn>
              <v-btn value="10" class="btnsExpirationDay">
                <span>10</span>
              </v-btn>
              <v-btn value="15" class="btnsExpirationDay">
                <span>15</span>
              </v-btn>
              <v-btn value="20" class="btnsExpirationDay">
                <span>20</span>
              </v-btn>
              <v-btn value="25" class="btnsExpirationDay">
                <span>25</span>
              </v-btn>
              <v-btn value="30" class="btnsExpirationDay">
                <span>30</span>
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-col>
      </v-row>
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn
        class="next-button container-center mb-5"
        @click="submit"
        elevation="0"
        color="#00C7BA"
        width="161"
        height="44"
      >
        <strong class="mr-2 next-button-label"> Preencher DPS </strong>
        <v-icon color="white">mdi-arrow-right-circle-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import banks from "../../../../assets/banks.json";

export default {
  name: "Proposal",

  created() {
    this.banks = banks;
    const parsedData = JSON.parse(localStorage.getItem("@GlobusVida:data"));
    if (parsedData) {
      this.proponente = parsedData;
    }

    if (this.proponente.beneficiarios) {
      this.beneficiarios = JSON.parse(this.proponente.beneficiarios);
    }
  },

  data() {
    return {
      banks: [],
      key: false,
      apiService: new ApiService(),
      proponente: {
        expirationDay: 0,
      },
      beneficiarios: [],
      participation: 0,
      rules: [(v) => !!v || "Campo obrigatório"],
      othersDegrees: "",
      retireeOptions: [
        {
          text: "Não",
          value: "nao",
        },
        {
          text: "Aposentado por Tempo de Serviço/Idade",
          value: "portempo",
        },
        {
          text: "Aposentado por Invalidez por Doença",
          value: "invalidezpordoenca",
        },
        {
          text: "Aposentado por Invalidez por Acidente",
          value: "invalidezporacidente",
        },
      ],
      genders: [
        {
          text: "Masculino",
          value: 0,
        },
        {
          text: "Feminino",
          value: 1,
        },
      ],
      generalOptions: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
    };
  },

  methods: {
    getCep() {
      if (this.proponente.cep && this.proponente.cep.length > 8) {
        const cep = this.proponente.cep.replace("-", "");

        this.apiService.get(`api/cep?cep=${cep}`).then((response) => {
          this.proponente.address = response.logradouro;
          this.proponente.neighbourhood = response.bairro;
          this.proponente.city = response.localidade;
          this.proponente.state = response.uf;
          this.key = !this.key;
        });
      }
    },

    TestDate(date) {
      const dateArray = date.split("/");

      let day = dateArray[0],
        month = dateArray[1],
        year = dateArray[2];

      let dayLimit;
      let month31 = ["01", "03", "05", "07", "08", "10", "12"];
      if (month === "02") {
        dayLimit = 28;
      } else if (month31.includes(month)) {
        dayLimit = 31;
      } else {
        dayLimit = 30;
      }

      day = dateArray[0] >= 1 && dateArray[0] <= dayLimit ? true : false;
      month = dateArray[1] >= 1 && dateArray[1] <= 12 ? true : false;
      year =
        dateArray[2] >= 1952 && dateArray[2] <= new Date().getFullYear()
          ? true
          : false;

      return day && month && year;
    },

    addRecipient() {
      this.beneficiarios.push({});
      this.currentBeneficiary = {};
    },

    removeRecipient(index, part) {
      this.participation += part;
      this.beneficiarios.splice(index, 1);
    },

    calcPercentage() {
      this.participation = 0;
      this.beneficiarios.map((beneficiario) => {
        this.participation += Number(
          beneficiario.participation.replace("%", "")
        );
      });
      return this.participation > 100 ? false : true;
    },

    submit() {
      if (
        this.$refs.form.validate() &&
        this.$refs.formBeneficiarios.validate()
      ) {
        const storagedData = JSON.parse(
          localStorage.getItem("@GlobusVida:data")
        );

        this.proponente = {
          ...this.proponente,
          ...storagedData,
          beneficiarios: JSON.stringify(this.beneficiarios),
        };

        localStorage.setItem(
          "@GlobusVida:data",
          JSON.stringify(this.proponente)
        );

        this.$emit("confirm");
      }
    },
  },
};
</script>

<style scoped>
.main-title {
  font-weight: normal;
  font-size: 31px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.fatherOfBtnExpirationDay {
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.btnsExpirationDay {
  border: none !important;
  border-radius: 0% !important;
}

@media (max-width: 445px) {
  .container-center {
    margin: 0 auto !important;
  }
}
</style>
